import React from 'react';
import ModularAppView from './ModularAppView';

export default function RemindersApp() {
  return (
    <ModularAppView
      slug="reminders"
      defaultTitle="Reminders"
      defaultIcon="BellRing"
      defaultCategory="Productivity"
    />
  );
}
